import * as sdpTransform from "sdp-transform";
import { AnswerMediaSection, OfferMediaSection } from "./MediaSection";
/*
"v=0
o=mozilla...THIS_IS_SDPARTA-81.0a1 2010187183123777834 1 IN IP4 0.0.0.0
s=-
t=0 0
a=fingerprint:sha-256 DE:1E:AD:9E:72:09:67:F3:F1:8D:2F:47:71:B3:21:17:7C:65:17:07:E2:9D:50:7C:64:87:69:FC:83:ED:CD:8D
a=group:BUNDLE 0 1 2 3
a=ice-options:trickle
a=msid-semantic:WMS *
m=audio 56219 UDP/TLS/RTP/SAVPF 109 9 0 8 101
c=IN IP4 94.31.102.177
a=candidate:0 1 UDP 2122187007 192.168.178.28 56219 typ host
a=candidate:5 1 UDP 2122252543 2a00:6020:b20c:200:81c5:f47b:293d:bbea 55631 typ host
a=candidate:10 1 TCP 2105458943 192.168.178.28 9 typ host tcptype active
a=candidate:12 1 TCP 2105524479 2a00:6020:b20c:200:81c5:f47b:293d:bbea 9 typ host tcptype active
a=candidate:1 1 UDP 1685987327 94.31.102.177 56219 typ srflx raddr 192.168.178.28 rport 56219
a=inactive
a=extmap:1 urn:ietf:params:rtp-hdrext:ssrc-audio-level
a=extmap:3 urn:ietf:params:rtp-hdrext:sdes:mid
a=fmtp:109 maxplaybackrate=48000;stereo=1;useinbandfec=1
a=fmtp:101 0-15
a=ice-pwd:aa2c5c314c5bcbbf380e7dec8ae57230
a=ice-ufrag:ee9195bd
a=mid:0
a=rtcp-mux
a=rtpmap:109 opus/48000/2
a=rtpmap:9 G722/8000/1
a=rtpmap:0 PCMU/8000
a=rtpmap:8 PCMA/8000
a=rtpmap:101 telephone-event/8000/1
a=setup:passive
a=ssrc:1097515466 cname:{94d6fb44-c36d-4bce-8302-bb5dc4e5b2ac}
m=video 9 UDP/TLS/RTP/SAVPF 126 127 120 124 121 125
c=IN IP4 0.0.0.0
a=inactive
a=extmap:5 urn:ietf:params:rtp-hdrext:toffset
a=extmap:4 http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time
a=extmap:7 http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01
a=extmap:6 http://www.webrtc.org/experiments/rtp-hdrext/playout-delay
a=extmap:3 urn:ietf:params:rtp-hdrext:sdes:mid
a=fmtp:126 profile-level-id=42e01f;level-asymmetry-allowed=1;packetization-mode=1
a=fmtp:127 apt=126
a=fmtp:120 max-fs=12288;max-fr=60
a=fmtp:124 apt=120
a=fmtp:121 max-fs=12288;max-fr=60
a=fmtp:125 apt=121
a=ice-pwd:aa2c5c314c5bcbbf380e7dec8ae57230
a=ice-ufrag:ee9195bd
a=mid:1
a=rtcp-fb:126 nack
a=rtcp-fb:126 nack pli
a=rtcp-fb:126 ccm fir
a=rtcp-fb:126 goog-remb
a=rtcp-fb:126 transport-cc
a=rtcp-fb:120 nack
a=rtcp-fb:120 nack pli
a=rtcp-fb:120 ccm fir
a=rtcp-fb:120 goog-remb
a=rtcp-fb:120 transport-cc
a=rtcp-fb:121 nack
a=rtcp-fb:121 nack pli
a=rtcp-fb:121 ccm fir
a=rtcp-fb:121 goog-remb
a=rtcp-fb:121 transport-cc
a=rtcp-mux
a=rtcp-rsize
a=rtpmap:126 H264/90000
a=rtpmap:127 rtx/90000
a=rtpmap:120 VP8/90000
a=rtpmap:124 rtx/90000
a=rtpmap:121 VP9/90000
a=rtpmap:125 rtx/90000
a=setup:passive
a=ssrc:274537565 cname:{94d6fb44-c36d-4bce-8302-bb5dc4e5b2ac}
a=ssrc:3402749119 cname:{94d6fb44-c36d-4bce-8302-bb5dc4e5b2ac}
a=ssrc-group:FID 274537565 3402749119
m=application 9 UDP/DTLS/SCTP webrtc-datachannel
c=IN IP4 0.0.0.0
a=sendrecv
a=ice-pwd:aa2c5c314c5bcbbf380e7dec8ae57230
a=ice-ufrag:ee9195bd
a=mid:2
a=setup:passive
a=sctp-port:5000
a=max-message-size:1073741823
m=audio 9 UDP/TLS/RTP/SAVPF 109 9 0 8 101
c=IN IP4 0.0.0.0
a=inactive
a=extmap:1 urn:ietf:params:rtp-hdrext:ssrc-audio-level
a=extmap:3 urn:ietf:params:rtp-hdrext:sdes:mid
a=fmtp:109 maxplaybackrate=48000;stereo=1;useinbandfec=1
a=fmtp:101 0-15
a=ice-pwd:aa2c5c314c5bcbbf380e7dec8ae57230
a=ice-ufrag:ee9195bd
a=mid:3
a=rtcp-mux
a=rtpmap:109 opus/48000/2
a=rtpmap:9 G722/8000/1
a=rtpmap:0 PCMU/8000
a=rtpmap:8 PCMA/8000
a=rtpmap:101 telephone-event/8000/1
a=setup:active
a=ssrc:1411125448 cname:{94d6fb44-c36d-4bce-8302-bb5dc4e5b2ac}
"
*/
/*
"v=0\r\no=mozilla...THIS_IS_SDPARTA-81.0a1 3454874581114871678 0 IN IP4 0.0.0.0\r\ns=-\r\nt=0 0\r\na=fingerprint:sha-256 D7:F5:AF:AD:33:C4:FE:7B:EA:AF:5C:5E:57:3A:A8:48:CD:0B:02:6C:1E:BC:A0:9B:D4:1B:7A:E0:A1:3B:A2:4D\r\na=group:BUNDLE 0 1 2\r\na=ice-options:trickle\r\na=msid-semantic:WMS *\r\nm=audio 9 UDP/TLS/RTP/SAVPF 109 9 0 8 101\r\nc=IN IP4 0.0.0.0\r\na=recvonly\r\na=extmap:1 urn:ietf:params:rtp-hdrext:ssrc-audio-level\r\na=extmap:2/recvonly urn:ietf:params:rtp-hdrext:csrc-audio-level\r\na=extmap:3 urn:ietf:params:rtp-hdrext:sdes:mid\r\na=fmtp:109 maxplaybackrate=48000;stereo=1;useinbandfec=1\r\na=fmtp:101 0-15\r\na=ice-pwd:9473cabff1a6d46d72ece31e59b0e54f\r\na=ice-ufrag:059d9038\r\na=mid:0\r\na=rtcp-mux\r\na=rtpmap:109 opus/48000/2\r\na=rtpmap:9 G722/8000/1\r\na=rtpmap:0 PCMU/8000\r\na=rtpmap:8 PCMA/8000\r\na=rtpmap:101 telephone-event/8000/1\r\na=setup:actpass\r\na=ssrc:3235606544 cname:{a24d0240-7f76-49de-b342-cca88e1427b7}\r\nm=video 0 UDP/TLS/RTP/SAVPF 126 127 120 124 121 125\r\nc=IN IP4 0.0.0.0\r\na=bundle-only\r\na=recvonly\r\na=extmap:3 urn:ietf:params:rtp-hdrext:sdes:mid\r\na=extmap:4 http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time\r\na=extmap:5 urn:ietf:params:rtp-hdrext:toffset\r\na=extmap:6/recvonly http://www.webrtc.org/experiments/rtp-hdrext/playout-delay\r\na=extmap:7 http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01\r\na=fmtp:126 profile-level-id=42e01f;level-asymmetry-allowed=1;packetization-mode=1\r\na=fmtp:127 apt=126\r\na=fmtp:120 max-fs=12288;max-fr=60\r\na=fmtp:124 apt=120\r\na=fmtp:121 max-fs=12288;max-fr=60\r\na=fmtp:125 apt=121\r\na=ice-pwd:9473cabff1a6d46d72ece31e59b0e54f\r\na=ice-ufrag:059d9038\r\na=mid:1\r\na=rtcp-fb:126 nack\r\na=rtcp-fb:126 nack pli\r\na=rtcp-fb:126 ccm fir\r\na=rtcp-fb:126 goog-remb\r\na=rtcp-fb:126 transport-cc\r\na=rtcp-fb:120 nack\r\na=rtcp-fb:120 nack pli\r\na=rtcp-fb:120 ccm fir\r\na=rtcp-fb:120 goog-remb\r\na=rtcp-fb:120 transport-cc\r\na=rtcp-fb:121 nack\r\na=rtcp-fb:121 nack pli\r\na=rtcp-fb:121 ccm fir\r\na=rtcp-fb:121 goog-remb\r\na=rtcp-fb:121 transport-cc\r\na=rtcp-mux\r\na=rtpmap:126 H264/90000\r\na=rtpmap:127 rtx/90000\r\na=rtpmap:120 VP8/90000\r\na=rtpmap:124 rtx/90000\r\na=rtpmap:121 VP9/90000\r\na=rtpmap:125 rtx/90000\r\na=setup:actpass\r\na=ssrc:3914232873 cname:{a24d0240-7f76-49de-b342-cca88e1427b7}\r\nm=application 0 UDP/DTLS/SCTP webrtc-datachannel\r\nc=IN IP4 0.0.0.0\r\na=bundle-only\r\na=sendrecv\r\na=ice-pwd:9473cabff1a6d46d72ece31e59b0e54f\r\na=ice-ufrag:059d9038\r\na=mid:2\r\na=setup:actpass\r\na=sctp-port:5000\r\na=max-message-size:1073741823\r\n"
*/
export class RemoteSdp {
    constructor(iceParameters, iceCandidates, dtlsParameters, plainRtpParameters, planB) {
        this.iceParameters = iceParameters;
        this.iceCandidates = iceCandidates;
        this.dtlsParameters = dtlsParameters;
        this.plainRtpParameters = plainRtpParameters;
        this.planB = planB;
        this.mediaSections = [];
        this.midToIndex = new Map();
        this.sdpObject = {
            version: 0,
            origin: {
                address: "0.0.0.0",
                ipVer: 4,
                netType: "IN",
                sessionId: 10000,
                sessionVersion: 0,
                username: "flavr-client"
            },
            name: "-",
            timing: { start: 0, stop: 0 },
            media: []
        };
        // If ICE parameters are given, add ICE-Lite indicator.
        if (iceParameters && iceParameters.iceLite) {
            this.sdpObject.icelite = "ice-lite";
        }
        // If DTLS parameters are given, assume WebRTC and BUNDLE.
        if (dtlsParameters) {
            this.sdpObject.msidSemantic = { semantic: "WMS", token: "*" };
            // NOTE: We take the latest fingerprint.
            /* const numFingerprints = this.dtlsParameters!.fingerprints.length;
      
                  this.sdpObject.fingerprint =
                  {
                      type : dtlsParameters.fingerprints[numFingerprints - 1].algorithm,
                      hash : dtlsParameters.fingerprints[numFingerprints - 1].value
                  }; */
            this.sdpObject.groups = [{ type: "BUNDLE", mids: "" }];
        }
        // If there are plain RPT parameters, override SDP origin.
        if (plainRtpParameters) {
            this.sdpObject.origin.address = plainRtpParameters.ip;
            this.sdpObject.origin.ipVer = plainRtpParameters.ipVersion;
        }
    }
    getSdp() {
        this.sdpObject.origin.sessionVersion++;
        return sdpTransform.write(this.sdpObject);
    }
    addMediaSection(newMediaSection) {
        if (!this.firstMid)
            this.firstMid = newMediaSection.mid;
        // Add to the vector.
        this.mediaSections.push(newMediaSection);
        // Add to the map.
        this.midToIndex.set(newMediaSection.mid, this.mediaSections.length - 1);
        // Add to the SDP object.
        this.sdpObject.media.push(newMediaSection.getObject());
        // Regenerate BUNDLE mids.
        this.regenerateBundleMids();
    }
    regenerateBundleMids() {
        if (!this.dtlsParameters)
            return;
        this.sdpObject.groups[0].mids = this.mediaSections
            .filter((mediaSection) => !mediaSection.closed)
            .map((mediaSection) => mediaSection.mid)
            .join(" ");
    }
    send(offerMediaObject, reuseMid, offerRtpParameters, answerRtpParameters, codecOptions, extmapAllowMixed = false) {
        const mediaSection = new AnswerMediaSection({
            iceParameters: this.iceParameters,
            iceCandidates: this.iceCandidates,
            dtlsParameters: this.dtlsParameters,
            plainRtpParameters: this.plainRtpParameters,
            planB: this.planB,
            offerMediaObject,
            offerRtpParameters,
            answerRtpParameters,
            codecOptions,
            extmapAllowMixed
        });
        // Unified-Plan with closed media section replacement.
        if (reuseMid) {
            this.replaceMediaSection(mediaSection, reuseMid);
        }
        else if (!this.midToIndex.has(mediaSection.mid)) {
            // Unified-Plan or Plan-B with different media kind.
            this.addMediaSection(mediaSection);
        }
        else {
            // Plan-B with same media kind.
            this.replaceMediaSection(mediaSection);
        }
    }
    receive(mid, kind, offerRtpParameters, streamId, trackId) {
        const idx = this.midToIndex.get(mid);
        let mediaSection;
        if (idx !== undefined)
            mediaSection = this.mediaSections[idx];
        // Unified-Plan or different media kind.
        if (!mediaSection) {
            mediaSection = new OfferMediaSection({
                iceParameters: this.iceParameters,
                iceCandidates: this.iceCandidates,
                dtlsParameters: this.dtlsParameters,
                plainRtpParameters: this.plainRtpParameters,
                planB: this.planB,
                mid,
                kind,
                offerRtpParameters,
                streamId,
                trackId
            });
            // Let's try to recycle a closed media section (if any).
            // NOTE: Yes, we can recycle a closed m=audio section with a new m=video.
            const oldMediaSection = this.mediaSections.find((m) => m.closed);
            if (oldMediaSection) {
                this.replaceMediaSection(mediaSection, oldMediaSection.mid);
            }
            else {
                this.addMediaSection(mediaSection);
            }
        }
        else {
            this.replaceMediaSection(mediaSection);
        }
    }
    replaceMediaSection(newMediaSection, reuseMid) {
        // Store it in the map.
        if (typeof reuseMid === "string") {
            const idx = this.midToIndex.get(reuseMid);
            if (idx === undefined) {
                throw new Error(`no media section found for reuseMid '${reuseMid}'`);
            }
            const oldMediaSection = this.mediaSections[idx];
            // Replace the index in the vector with the new media section.
            this.mediaSections[idx] = newMediaSection;
            // Update the map.
            this.midToIndex.delete(oldMediaSection.mid);
            this.midToIndex.set(newMediaSection.mid, idx);
            // Update the SDP object.
            this.sdpObject.media[idx] = newMediaSection.getObject();
            // Regenerate BUNDLE mids.
            this.regenerateBundleMids();
        }
        else {
            const idx = this.midToIndex.get(newMediaSection.mid);
            if (idx === undefined) {
                throw new Error(`no media section found with mid '${newMediaSection.mid}'`);
            }
            // Replace the index in the vector with the new media section.
            this.mediaSections[idx] = newMediaSection;
            // Update the SDP object.
            this.sdpObject.media[idx] = newMediaSection.getObject();
        }
    }
}
